import React, { useEffect, useState } from 'react';
import './login.css';
import { Navigate } from 'react-router-dom';
import { useAuthenticate } from '../../hooks';
import { DASHBOARD_PATH } from '../../router/RouteConstants';
import Header from '../../components/layout/Header/Header';
import AIEduButton from '../../components/common/Button/AIEduButton';
import googleIcon from '../../assets/images/google_colored_login.png';
import microsoftIcon from '../../assets/images/microsoft_colored_login.png';
import { useIntl } from 'react-intl';
import { API } from '../../services';
import { APP_VERSION } from '../../utils/Constants';

const Login = () => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const { auth } = useAuthenticate();

    const [termUrl, setTermUrl] = useState(null);
    const [policyUrl, setPolicyUrl] = useState(null);

    const LOGIN_URL =
        process.env.REACT_APP_AI_ASSISTANCE_HOST + '/ums/auth/login';

    const handleGoogleSignInBtnClick = async () => {
        window.location.replace(LOGIN_URL);
    };

    const handleMicrosoftSignInBtnClick = async () => {
        window.location.replace(`${LOGIN_URL}?idp=microsoft`);
    };

    const SignInButtonStyle = ({ text, icon, handleClick, btnStyle }) => {
        return (
            <AIEduButton
                className={btnStyle}
                severity='secondary'
                label={
                    <div className='flex' style={{ marginLeft: '2.3rem' }}>
                        <div className='account_logo'>
                            <img src={icon} />
                        </div>
                        <div className='flex align-items-center'>{text}</div>
                    </div>
                }
                onClick={handleClick}
                outlined
            />
        );
    };

    useEffect(() => {
        if (auth) {
            return;
        }

        API.getTermsAndPolicy('orgId').then(({ data }) => {
            const { terms } = data;
            setTermUrl(terms?.[0]?.termUrl);
            setPolicyUrl(terms?.[1]?.termUrl);
        });
    }, []);

    const handleNavigation = (url) => {
        if (!url) return;
        window.open(url, '_blank');
    };

    if (auth) {
        return <Navigate to={DASHBOARD_PATH} />;
    }

    return (
        <div className='page-layout'>
            <Header isLoginPage={true} />
            <div className='login'>
                <main className='main'>
                    <div className='main-header'>Sign In</div>
                    <div className='login-text'>
                        Get started with Samsung AI Assistant
                    </div>
                    <div className='signin-options'>
                        <SignInButtonStyle
                            text='Continue with Google'
                            icon={googleIcon}
                            btnStyle='btn btnPrimary'
                            handleClick={handleGoogleSignInBtnClick}
                        />
                        <SignInButtonStyle
                            text='Continue with Microsoft'
                            icon={microsoftIcon}
                            btnStyle='btn btnPrimary'
                            handleClick={handleMicrosoftSignInBtnClick}
                        />
                    </div>
                </main>
                <footer className='footer'>
                    <div
                        style={{
                            position: 'absolute',
                            bottom: '1.8rem',
                            left: '5%',
                        }}
                    >
                        Server Version {APP_VERSION}
                    </div>
                    <div
                        onClick={() => handleNavigation(termUrl)}
                        className='cursor-pointer hover:underline'
                    >
                        Terms and Condition
                    </div>
                    <div
                        onClick={() => handleNavigation(policyUrl)}
                        className='cursor-pointer hover:underline'
                    >
                        Privacy Policy
                    </div>
                    <div>
                        Copyright &copy; Samsung Electronics Co., Ltd. All
                        Rights Reserved.
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default Login;
